import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import Workshops from "@/components/Workshops";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Cranio from "@/components/Cranio";
import CranioMensch from "@/components/CranioMensch";
import CranioPferd from "@/components/CranioPferd";
import CranioHund from "@/components/CranioHund";
import Trauerreden from "@/components/Trauerreden";

Vue.use(Router);

export default new Router({
  mode: "history",
  hash: false,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }, 
  routes: [
    {
      path: "/",
      name: "Startseite",
      component: Home,
    },
    {
      path: "/uebermich",
      name: "Über mich",
      component: About,
    },
    {
      path: "/workshops",
      name: "Workshops",
      component: Workshops,
    },
    {
      path: "/kontakt",
      name: "Kontakt",
      component: Contact,
    },
    {
      path: "/energiebalance",
      name: "Craniosacrale Energiebalance",
      component: Cranio,
    },
    {
      path: "/trauerreden",
      name: "Trauerreden",
      component: Trauerreden,
    },
    {
      path: "/energiebalance-mensch",
      name: "Craniosacrale Energiebalance für Menschen",
      component: CranioMensch,
    },
    {
      path: "/energiebalance-pferd",
      name: "Craniosacrale Energiebalance für Pferde",
      component: CranioPferd,
    },
        {
      path: "/energiebalance-hund",
      name: "Craniosacrale Energiebalance für Hunde",
      component: CranioHund,
    },
    {
      path: "*",
      name: "Startseite",
      component: Home,
    }
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js